import UploadDocument from "./upload-document";

export default UploadDocument;
